import React from 'react';
import {
  Alert,
  Badge,
} from 'react-bootstrap';
import PMono from './p/PMono'
import PText from './p/PText'
import utils from '../utils'



export default class EcuMessageIdPcb extends React.Component {
  //constructor(props) {    
  //  super(props)    
  //}
  render() {
    if (this.props.data === undefined) 
      return ""

    var w0 = this.props.data.w0
    var w1 = this.props.data.w1

    var t_w0 = "0x" + (utils.decimalToHex(w0[0]) + utils.decimalToHex(w0[1])).toUpperCase()
    var t_w1 = "0x" + (utils.decimalToHex(w1[0]) + utils.decimalToHex(w1[1])).toUpperCase()
    var t_name = utils.getNameFromIdPcb(t_w0, t_w1)
    if (t_name === undefined) {
      t_name = "MODEL NOT FOUND !"
    }

    var hex_bytes = utils.byteArrayToHex(this.props.data._b)
    var ko_visible = (!this.props.data.res) ? "visually-hidden" : ""
    
    return (
      <>          
        <Alert variant="info">
          <Alert.Heading>{this.props.title} <Badge bg="danger" className={ko_visible}>KO</Badge></Alert.Heading>
          <PMono value={hex_bytes} />
          <hr />
          <PMono label="w0" value={t_w0} />
          <PMono label="w1" value={t_w1} />
          <PText value=""   description={t_name} />
        </Alert>
      </>
    )
  }
}
